'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Hamburgler;
(function (Hamburgler) {
    var MyHamburgler = /** @class */ (function () {
        function MyHamburgler() {
            $(document).ready(function () {
                $('.trigHamburgler').click(function (e) {
                    e.preventDefault();
                    $('.bulletHamburgler').toggleClass('no-hamburgler');
                    $('.bulletMenu').toggleClass('no-hamburgler');
                    $('.bulletNaviBackLayer').toggleClass('no-hamburgler');
                });
            });
            $(document).on('click touchend', '.bulletNaviBackLayer.no-hamburgler', function (e) {
                e.preventDefault();
                $('.bulletHamburgler').removeClass('no-hamburgler');
                $('.bulletMenu').removeClass('no-hamburgler');
                $('.bulletNaviBackLayer').removeClass('no-hamburgler');
            });
        }
        return MyHamburgler;
    }());
    Hamburgler.MyHamburgler = MyHamburgler;
})(Hamburgler || (Hamburgler = {}));
exports.default = Hamburgler;
